<template>
  <a-table
    :columns="columns"
    :dataSource="data"
    :loading="loading"
    :pagination="false"
    rowKey="teacher_name"
    @change="onTableChange"
  >
    <template slot="progress" slot-scope="text">
      <a-progress :percent="text" :strokeColor="text < 60 ? 'red' : text < 80 ? 'orange' : 'green'" />
    </template>

    <template slot="actions" slot-scope="record">
      <a-button type="primary" @click="$emit('viewDetails', record)">View Details</a-button>
    </template>
  </a-table>
</template>

<script>
export default {
  props: {
    data: Array,
    loading: Boolean,
  },

  data() {
    return {
      columns: [
        { title: 'Teacher Name', dataIndex: 'teacher_name', key: 'teacher_name', sorter: true },
        { title: 'No. of Lesson Plans', dataIndex: 'no_of_lesson_plans', key: 'no_of_lesson_plans', align: 'center' },
        { title: 'No. of Sections', dataIndex: 'no_of_sections', key: 'no_of_sections', align: 'center' },
        { title: 'Total Updates Logged', dataIndex: 'total_updates_logged', key: 'total_updates_logged', align: 'center' },
        { title: 'Avg. Completion Rate', dataIndex: 'avg_completion_rate', key: 'avg_completion_rate', scopedSlots: { customRender: 'progress' }, align: 'center' },
        { title: 'Lagging Sections', dataIndex: 'lagging_sections', key: 'lagging_sections', align: 'center' },
        { title: 'Actions', key: 'actions', scopedSlots: { customRender: 'actions' }, align: 'center' },
      ],
    }
  },

  methods: {
    onTableChange(pagination, filters, sorter) {
      this.$emit('updateTable', [sorter.field, sorter.order, filters])
    },
  },
}
</script>
